import { NgOptimizedImage } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DomSanitizer } from '@angular/platform-browser';
import { PageData } from 'src/app/shared/models/page-data.model';
import { PageDataService } from 'src/app/shared/services/page-data.service';

@Component({
  selector: 'app-notice',
  imports: [MatProgressSpinnerModule, NgOptimizedImage],
  templateUrl: './notice.component.html',
  styleUrl: './notice.component.scss',
})
export class NoticeComponent implements OnInit {
  private readonly pageDataService = inject(PageDataService);
  private readonly sanitizer = inject(DomSanitizer);

  noticeSection?: PageData;

  async ngOnInit() {
    this.noticeSection = await this.pageDataService.getPageData('landing', 'notice');
    this.noticeSection.data = this.sanitizer.bypassSecurityTrustHtml(this.noticeSection.data as string);
  }
}
